import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ShieldCheck, Phone, Mail, MapPin, CircleCheck, CircleX } from 'lucide-react';
import { getClientData } from "./custom";

function Profile() {
  const navigate = useNavigate();

  const [clients, setClients] = useState([]);

  useEffect(() => {
    const clientData = getClientData();
    if (clientData) {
      setClients(clientData);
    }

  }, []);

  // Extract the first letter of first_name and last_name, and combine them
  const initials = (clients.first_name?.charAt(0).toUpperCase() || '') + (clients.last_name?.charAt(0).toUpperCase() || '');

  const handleGoBack = () => {
    navigate("/account");
  };

  return (
    <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
      <div className="h-screen overflow-y-scroll p-4 pb-20 flex-grow max-w-sm min-w-[375px] w-full bg-white 
            [&::-webkit-scrollbar]:w-1 
            [&::-webkit-scrollbar-track]:bg-transparent 
            [&::-webkit-scrollbar-thumb]:bg-transparent 
            scrollbar-thin scrollbar-track-transparent scrollbar-thumb-transparent">
        <p className="text-base leading-6 mb-[15px] mt-0 tracking-wide font-lato font-normal flex items-center">
          <span className="font-black me-2">
            <ChevronLeft size={16} onClick={handleGoBack} />
          </span>
          Profile
        </p>

        <div className="relative flex flex-col items-center mb-3 bg-gray-100 pt-10 pb-6 rounded-lg">
          {/* Circle Avatar */}
          <div className="absolute -top-10 bg-pink-100 text-red-800 rounded-full w-20 h-20 flex items-center justify-center shadow-md">
            <span className="text-xl font-lato font-semibold">{initials}</span>
          </div>

          {/* User Info */}
          <h3 className="font-[14px]  mb-0 mt-4">{clients.first_name} {clients.last_name}</h3>
          <p className="text-[12px] font-lato">I.D: {clients.client_username}</p>
        </div>

        <div className="flex items-center bg-gray-100 rounded-lg p-3 mb-2 h-auto w-full">
          <div className="flex flex-col">
            <span className="font-lato text-s ml-6">User ID</span>
            <div className="flex items-center">
              <ShieldCheck className="w-4 h-4 mr-2" />
              <span className="font-lato text-sm font-semibold leading-1">{clients.client_username}</span>
            </div>
          </div>
        </div>

        {/* Personal Detail Section */}
        <div className="flex items-center bg-gray-100 rounded-lg p-3 mb-3 h-auto w-full relative">
          <div className="flex flex-col w-full relative">
            <span className="font-lato text-base mb-3">Personal Details</span>
            <div className="flex flex-col border-b pb-2 relative mb-4">
              <span className="font-lato text-sm ml-6 mb-1 text-gray-400">Mobile Number</span>
              <div className="flex items-end">
                <Phone className="w-4 h-4 mr-2" />
                <span className="font-lato text-sm font-semibold leading-none">{clients.contact}</span>
              </div>
            </div>

            <div className="flex flex-col border-b pb-2 relative mb-4">
              <span className="font-lato text-sm ml-6 mb-1 text-gray-400">Email</span>
              <div className="flex items-end">
                <Mail className="w-4 h-4 mr-2" />
                <span className="font-lato text-sm font-semibold leading-none">{clients.email}</span>
              </div>
            </div>

            <div className="flex flex-col pb-2 relative">
              <span className="font-lato text-sm ml-6 mb-1 text-gray-400">Location</span>
              <div className="flex items-end">
                <MapPin className="w-4 h-4 mr-2" />
                <span className="font-lato text-sm font-semibold leading-none">-</span>
              </div>
            </div>
          </div>
        </div>

        {/* Segment Subscriptions Section */}
        <div className="flex items-center bg-gray-100 rounded-lg p-3 mb-3 h-auto w-full relative">
          <div className="flex flex-col w-full relative">
            <span className="font-lato text-base mb-[30px]">Segment Subscriptions</span>
            <div className="flex items-center justify-center  border-b p-2">
              <span className="font-lato text-sm">Equity Trading</span>
              {clients?.client_account?.is_equity_trading_active === 'yes' ? <CircleCheck className="w-4 h-4 ml-auto text-[#4cd964]" /> : <CircleX className="w-4 h-4 ml-auto text-[#d94c4c]" />}
            </div>
            <div className="flex items-center justify-center  border-b p-2">
              <span className="font-lato text-sm">Equity Index Trading</span>
              {clients?.client_account?.is_equity_index_trading_active === 'yes' ? <CircleCheck className="w-4 h-4 ml-auto text-[#4cd964]" /> : <CircleX className="w-4 h-4 ml-auto text-[#d94c4c]" />}
            </div>
            <div className="flex items-center justify-center  border-b p-2">
              <span className="font-lato text-sm">MCX Trading</span>
              {clients?.client_account?.is_mcx_trading_active === 'yes' ? <CircleCheck className="w-4 h-4 ml-auto text-[#4cd964]" /> : <CircleX className="w-4 h-4 ml-auto text-[#d94c4c]" />}
            </div>

            <div className="flex items-center justify-center  border-b p-2">
              <span className="font-lato text-sm">CDS Trading</span>
              {clients?.client_account?.is_cds_trading_active === 'yes' ? <CircleCheck className="w-4 h-4 ml-auto text-[#4cd964]" /> : <CircleX className="w-4 h-4 ml-auto text-[#d94c4c]" />}
            </div>
            <div className="flex items-center justify-center  border-b p-2">
              <span className="font-lato text-sm">US Trading</span>
              {clients?.client_account?.is_us_trading_active === 'yes' ? <CircleCheck className="w-4 h-4 ml-auto text-[#4cd964]" /> : <CircleX className="w-4 h-4 ml-auto text-[#d94c4c]" />}
            </div>
            <div className="flex items-center justify-center  border-b p-2">
              <span className="font-lato text-sm">CRYPTO Trading</span>
              {clients?.client_account?.is_crypto_trading_active === 'yes' ? <CircleCheck className="w-4 h-4 ml-auto text-[#4cd964]" /> : <CircleX className="w-4 h-4 ml-auto text-[#d94c4c]" />}
            </div>
            <div className="flex items-center justify-center  border-b p-2">
              <span className="font-lato text-sm">FOREX Trading</span>
              {clients?.client_account?.is_forex_trading_active === 'yes' ? <CircleCheck className="w-4 h-4 ml-auto text-[#4cd964]" /> : <CircleX className="w-4 h-4 ml-auto text-[#d94c4c]" />}
            </div>
          </div>
        </div>

      </div>
    </div >
  );
}

export default Profile;